import { call, put, select, takeLatest } from 'redux-saga/effects';

import makeSagaRequest from 'app/shared/sagas/makeSagaRequest';

// Models
import { CreateSarPayload } from 'app/modules/fincenSAR/requests';
import { SarActionTypes } from 'app/modules/fincenSarOld/models';
import { ReportType } from 'app/modules/filings/constants';

// Selectors
import { selectNewSarContent } from 'app/modules/fincenSarOld/selectors';

// Actions
import {
  createSar,
  createNewSar as createNewSarAction,
} from 'app/modules/fincenSarOld/actions';

const rootAction = SarActionTypes.CREATE_NEW_SAR;

export const getNewSarContentSourceId = (
  payload: Pick<CreateSarPayload, 'case_ids' | 'alert_ids'>,
) => {
  if (payload.case_ids?.length) {
    return payload.case_ids.length === 1 ? payload.case_ids[0] : undefined;
  }

  return payload.alert_ids?.[0];
};

function* createNewSar({ payload }: ReturnType<typeof createNewSarAction>) {
  const config = {
    rootAction,
    request: call(() => {}),
    success: function* onSuccess() {
      const content = yield select(
        selectNewSarContent(
          payload.name,
          // Multi-case SARs should not seed a single case id into the
          // internal control file number fields.
          getNewSarContentSourceId(payload),
        ),
      );

      const payloadWithContent: CreateSarPayload = {
        ...payload,
        content,
        report_type: ReportType.FINCEN_SAR,
      };

      yield put(createSar(payloadWithContent));
    },
  };

  yield call(makeSagaRequest, config);
}

export default function* watchCreateNewSar() {
  yield takeLatest(rootAction, createNewSar);
}
